// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eafOYIu_Ow4eWiMkplFy{align-items:center;display:flex}.zYCELXvyw0I_tBpRzUlf{color:var(--content-primary-secondary);font-size:13px;font-weight:400}.OfgIMahAhMAjxHuGTLjJ{color:var(--content-primary-secondary);margin-right:4px}.OfgIMahAhMAjxHuGTLjJ.lIsmRR0XVAkmlOiJ7s5y{color:var(--content-negative-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `eafOYIu_Ow4eWiMkplFy`,
	"label": `zYCELXvyw0I_tBpRzUlf`,
	"icon": `OfgIMahAhMAjxHuGTLjJ`,
	"faked": `lIsmRR0XVAkmlOiJ7s5y`
};
export default ___CSS_LOADER_EXPORT___;
